/* eslint-disable */
import { Grid, RACButton, RACSelect, Typography } from "@rentacenter/racstrap";
import { ExcelPreviewStyles } from "../Styles/ExcelPreview";

interface ExcelPreviewPaginationProps {
  totalRows: number;
  currentPage: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rows: number) => void;
}

export default function ExcelPreviewPagination({
  totalRows,
  currentPage,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: ExcelPreviewPaginationProps) {
  const classes = ExcelPreviewStyles();
  const totalPages = Math.ceil(totalRows / rowsPerPage);

  const getPageNumbers = (): (number | string)[] => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages: (number | string)[] = [];

    if (currentPage <= 3) {
      // Near the start: show first few pages + ellipsis + last page
      for (let i = 1; i <= Math.min(currentPage + 1, 4); i++) {
        pages.push(i);
      }
      pages.push("...");
      pages.push(totalPages);
    } else if (currentPage >= totalPages - 2) {
      // Near the end: show first page + ellipsis + last few pages
      pages.push(1);
      pages.push("...");
      for (let i = Math.max(totalPages - 3, currentPage - 1); i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Middle: show first page + ellipsis + neighbors + ellipsis + last page
      pages.push(1);
      pages.push("...");
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        pages.push(i);
      }
      pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  const handleRowsPerPageChange = (e: any) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value)) {
      onRowsPerPageChange(value);
    }
  };

  return (
    <Grid container justifyContent="flex-end" alignItems="center" className={classes.paginationBar}>
      {totalRows > 0 && (
        <Typography style={{ fontFamily: "OpenSans-semibold", fontSize: "0.875rem", marginRight: "16px" }}>
          Total records: {totalRows}
        </Typography>
      )}

      <Typography style={{ fontFamily: "OpenSans-semibold", fontSize: "0.875rem", marginRight: "8px" }}>
        Rows per page:
      </Typography>
      <Grid item style={{ width: "70px" }}>
        <RACSelect
          options={[
            { label: "10", value: "10" },
            { label: "25", value: "25" },
            { label: "50", value: "50" },
            { label: "100", value: "100" },
          ]}
          defaultValue={String(rowsPerPage)}
          onChange={handleRowsPerPageChange}
        />
      </Grid>

      <Grid item style={{ display: "flex", alignItems: "center", marginLeft: "16px" }}>
        <RACButton
          variant="text"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          style={{ minWidth: "32px", padding: "5px 4px" }}
        >
          &lt;
        </RACButton>

        {getPageNumbers().map((page, index) =>
          page === "..." ? (
            <Typography
              key={`ellipsis-${index}`}
              style={{
                padding: "5px 4px",
                fontFamily: "OpenSans-semibold",
                fontSize: "0.875rem",
              }}
            >
              ...
            </Typography>
          ) : (
            <RACButton
              key={`page-${page}`}
              variant="text"
              onClick={() => onPageChange(page as number)}
              style={{
                minWidth: "28px",
                height: "28px",
                borderRadius: "4px",
                backgroundColor: currentPage === page ? "#e0e0e0" : "transparent",
                color: currentPage === page ? "#000" : "#000",
                fontWeight: currentPage === page ? "bold" : "normal",
                fontFamily: "OpenSans-semibold",
                fontSize: "0.875rem",
                padding: "4px",
              }}
            >
              {page}
            </RACButton>
          )
        )}

        <RACButton
          variant="text"
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => onPageChange(currentPage + 1)}
          style={{ minWidth: "32px", padding: "5px 4px" }}
        >
          &gt;
        </RACButton>
      </Grid>
    </Grid>
  );
}
